import { Tabs } from 'antd';
import ProfileLayout from '../components/ProfileLayout/ProfileLayout';
import { GridContainer } from 'shared/ui';
import { useIntl } from 'react-intl';
import { SettingsLayout } from '../components/SettingsLayout/SettingsLayout';

const ProfilePage = () => {
  const { formatMessage: t } = useIntl();

  return (
    <GridContainer>
      <Tabs items={[
        {
          key: '1',
          label: t({ id: 'profilePage.profile' }),
          children: <ProfileLayout />
        },
        {
          key: '2',
          label: t({ id: 'profilePage.settings' }),
          children: <SettingsLayout />
        }
      ]} />
    </GridContainer>
  )
}

export default ProfilePage;